var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewDocumentImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 36,
    viewBox: "0 0 28 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.5 35.5V0.5H18.793L27.5 9.207V35.5H0.5Z",
    fill: "#EBFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.586 1L27 9.414V35H1V1H18.586ZM19 0H0V36H28V9L19 0Z",
    fill: "#4076B4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.5 9.5V0.5H18.793L27.5 9.207V9.5H18.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M19 1.414L26.586 9H19V1.414ZM19 0H18V10H28V9L19 0Z",
    fill: "#4076B4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewDocumentImg);
export default __webpack_public_path__ + "static/media/new_document_img.e6543e5049e0f89636b28f73fb8aab1d.svg";
export { ForwardRef as ReactComponent };